let pipsySettings = {
	name: "Pipsy",
	url: "https://caldwell-server.pipsy.io",
	ep: "https://caldwell-server.pipsy.io",
	logoDark: "https://pipsy-corporate.s3.amazonaws.com/logo.svg",
	logo: "https://pipsy-corporate.s3.amazonaws.com/logo.svg",
	gmapsApiKey: "AIzaSyCf15XncWAeC9KWsMHw7G4SFyfJqF9atZ0",
	mapboxKey:
		"pk.eyJ1IjoiYWFyb25jcmF3Zm9yZCIsImEiOiJja3cwdDMwMXM3MTFxMnRudW1pZHFvam50In0.3QVp7DXj2C_AhF360QHk0Q",
	s3: "https://pipsy-caldwell.s3.us-east-2.amazonaws.com",
	sentry:
		"https://807f173c8e894ef4932be5364e663193@o412318.ingest.sentry.io/5974718",
	mapsCenter: {
		lat: 29.7775124,
		lng: -95.3942879,
	},
	execMapCenter: {
		lat: 29.437834,
		lng: -95.416711,
	},
	heatMapRadius: 130,
	noEmailAddress: "info@pipsy.io",
	issueEmail: "info@pipsy.io",
	salesGoal: 250,
	groups: {
		arc: 14,
		salespeople: 13,
		dev: 1,
		sales_managers: 2,
	},
	localFields: {
		//lotPremiums: ["Lake Premium", "Other Premium"],
		trueUp: {
			"True Up Calculation Type": {
				type: "Dropdown",
				options: [
					{ label: "Base Lot Price (B)", value: "B" },
					{ label: "Base Lot Price + Premium (D)", value: "D" },
					{ label: "Base Lot Price + Interest (A)", value: "A" },
					{ label: "Base Lot Price + Interest + Premium (C)", value: "C" },
					{ label: "20% AHSP - Base Lot Price (E)", value: "E" },
					{ label: "No True Up (F)", value: "F" },
				],
			},
			"True Up Percentage": {
				type: "NumberField",
				options: { thousandSeparator: true, float: true },
			},
			"Total True Up Fee": {
				type: "TotalTrueUp",
			},
			"True Up Fee Paid": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			"True Up Cap": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			"True Up Minimum": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			"True Up Fee Balance Due": {
				type: "TrueUpBalance",
			},
			"True Up Date Paid": {
				type: "DateField",
				options: {},
			},
			"True Up Check Number": {
				type: "Field",
				options: {},
			},
			"Interest Start Date": {
				type: "DateField",
				options: {},
			},
			"Interest Rate": {
				type: "NumberField",
				options: {
					float: true,
				},
			},
			"Interest Accrued": {
				type: "InterestAccrued",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
		},
		lotPricing: {
			"Escalation Fee": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			"Mowing Fee": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			"Total Lot Price": {
				type: "Sum",
				fields: ["base_price", "premium", "Escalation Fee"],
			},
			"Lot Premium Paid?": {
				type: "Dropdown",
				options: [
					{ label: "Yes", value: 1 },
					{ label: "No", value: 0 },
				],
			},
		},
		marketingFees: {
			"Marketing Fee Type": {
				type: "Dropdown",
				options: ["Percentage", "Flat Fee"],
			},
			"Marketing Fee %": {
				type: "NumberField",
				options: {
					float: true,
				},
			},
			"Initial Marketing Fee": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Total Marketing Fee": {
				type: "TotalMarketingFee",
			},
			"Marketing Fee Paid": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Marketing Fee Balance Due": {
				type: "MarketingFeeDue",
			},
			"Marketing Fee Date Paid": {
				type: "DateField",
				options: {},
			},
			"Marketing Fee Check Number": {
				type: "Text",
				options: {},
			},
		},
		lot: {
			"Amenity Contribution": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Amenity Contribution %": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					float: true,
				},
			},
			"Remaining Marketing Fee": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Amenity Contribution Paid": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Amenity Contribution Date Paid": {
				type: "DateField",
				options: {},
			},
			"Amenity Contribution Balance Due": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
					float: true,
				},
			},
			"Amenity Contribution Check Number": {
				type: "NumberField",
				options: {},
			},
			"Pool Cost": {
				type: "NumberField",
				options: {
					thousandSeparator: true,
					prefix: "$",
				},
			},
			/* "Is Premium?": {
				type: "Dropdown",
				options: [
					{ label: "Yes", value: 1 },
					{ label: "No", value: 0 },
				],
			}, */
		},
	},
	specialFields: {
		start: {},
		lot: {
			lot: {},
			construction: {},
		},
	},
	noRealtorTracking: [], // For communities that do not track realtors.  Exclude from calculating realtor involved %'s.
	colors: ["#E5C67B"],
	primaryColor: "#1e3652",
	salesMeterHideProperties: [],
	serverPort: 8216,
	arc: true,
	weeklyDevUserVisibility: [
		//{ id: "sqft", name: "Square Feet", type: "average", devOnly: true },
		{ id: "price", name: "Price", type: "dollar", devOnly: true },
		{ id: "sale_date", name: "Sale Date", type: "date", devOnly: true },
		{
			id: "builderVRealtor",
			name: "Builder v Realtor",
			type: "text",
			devOnly: true,
		},
		{ id: "dirtVSpec", name: "Dirt v Spec", type: "text", devOnly: true },
	],
	additionalTrafficFields: [
		{
			type: "street",
		},
		{
			type: "city",
		},
		{
			type: "state",
		},
		{
			type: "zip",
		},
		{
			type: "how_much",
			options: [
				"Below $300,000",
				"$300K - $400K",
				"$400K - $500K",
				"$500K - $600K",
				"$600K - $750K",
				"$750K - $1 million",
				"Over $1 million",
			],
		},
		{
			type: "timeframe",
			options: [
				"Immediately",
				"1 Month - 3 Months",
				"4 Months - 6 Months",
				"6 Months - 1 Year",
				"1 - 2 Years",
				"3+ Years",
				"Just looking",
			],
		},
		{
			type: "want_text",
			options: [
				{ value: 1, label: "Yes" },
				{ value: 0, label: "No" },
			],
		},
	],
	takedownCalc: ["base_price", "premium", "addl.[Escalation Fee]"],
	enabled: {
		contractBasePrices: true,
		weeklyAnalytics: true,
		infoCenterSplit: true,
		openHouses: true,
		weekly: {
			lotTypeBuilderStackedBar: true,
			showPriceInTables: true,
		},
		extendedLotInventoryColumns: true,
		entryBuilderDeveloperLotMap: true,
		buyer_phone: true,
		lotReservations: [3],
		builderWebsiteInfo: true,
		zonda: true,
		documentManagement: true,
		infoCenterLeads: true,
		//salesRepUploadHUD: [1, 2, 4, 5],
		arcClosingAbility: [1, 2, 4, 5],
		hudDocs: [1, 2, 3, 4, 5],
		buildTime: {
			enabled: true,
			monthsDeadline: 24,
			builders: [54, 63],
		},
		lotManagement: {
			showBasePrice: true,
			showPremium: true,
			hideTakedownPrice: true,
		},
	},
	disabled: {
		entryLotMap: true,
	},
	weekly: {
		restrictSalesMeter: true,
		summary: true,
		splitTraffic: true, // builder vs welcome
		mapping: true,
		closingsDaysToClose: true,
	},
	renames: {
		starts: "Homes Under Construction",
	},
	specTerminology: "Showcase Home",
	requireSaleEmail: true,
	weeklyReportShowAllDetails: false,
	optionalEntryModules: [
		{
			title: "COMPETITION",
			icon: "fa-chart-pie",
			link: "/entry/competition",
		},
		{
			title: "ARC PORTAL",
			icon: "fa-upload",
			link: "/entry/arc",
		},
	],
	optionManagerModules: [
		{
			title: "COMPETITION",
			icon: "fa-chart-pie",
			link: "/salesManager/competition",
		},
	],
	disablePaperwork: true,
	requirePaperworkBeforeClosing: true,
	renderOverrides: {
		executive: "CaldwellExecutive",
	},
	additionalContractFields: {
		global: [],
		communitySpecific: {
			4: [
				{
					label: "Primary Birthday",
					name: "primary_birthday",
					type: "date",
					required: true,
					validation: "date",
					special: {
						numYears: 55,
					},
				},
				{
					label: "Co Birthday",
					name: "co_birthday",
					type: "date",
				},
			],
		},
	},
	additionalLotManagementColumns: [
		{
			Header: "Site Type",
			accessor: "Site Type",
			show: true,
			disableFilter: false,
			colType: "text",
		},
	],
	messagingMultiFamily: true,
	useFloorplanManualBasePricing: true,
}

module.exports = pipsySettings
